// Minimal E.164 helpers + a curated country dial-code list for the phone selector.
export const COUNTRIES = [
  { code: "US", dial: "+1", label: "United States" },
  { code: "CA", dial: "+1", label: "Canada" },
  { code: "GB", dial: "+44", label: "United Kingdom" },
  { code: "IE", dial: "+353", label: "Ireland" },
  { code: "AU", dial: "+61", label: "Australia" },
  { code: "NZ", dial: "+64", label: "New Zealand" },
  { code: "IN", dial: "+91", label: "India" },
  { code: "SG", dial: "+65", label: "Singapore" },
  { code: "AE", dial: "+971", label: "United Arab Emirates" },
  { code: "ZA", dial: "+27", label: "South Africa" },
  { code: "DE", dial: "+49", label: "Germany" },
  { code: "FR", dial: "+33", label: "France" },
  { code: "ES", dial: "+34", label: "Spain" },
  { code: "IT", dial: "+39", label: "Italy" },
  { code: "NL", dial: "+31", label: "Netherlands" },
  { code: "SE", dial: "+46", label: "Sweden" },
  { code: "NO", dial: "+47", label: "Norway" },
  { code: "DK", dial: "+45", label: "Denmark" },
  { code: "CH", dial: "+41", label: "Switzerland" },
  { code: "PT", dial: "+351", label: "Portugal" },
  { code: "PL", dial: "+48", label: "Poland" },
  { code: "MX", dial: "+52", label: "Mexico" },
  { code: "BR", dial: "+55", label: "Brazil" },
  { code: "AR", dial: "+54", label: "Argentina" },
  { code: "JP", dial: "+81", label: "Japan" },
  { code: "KR", dial: "+82", label: "South Korea" },
  { code: "CN", dial: "+86", label: "China" },
  { code: "HK", dial: "+852", label: "Hong Kong" },
  { code: "PH", dial: "+63", label: "Philippines" },
  { code: "MY", dial: "+60", label: "Malaysia" },
  { code: "ID", dial: "+62", label: "Indonesia" },
  { code: "NG", dial: "+234", label: "Nigeria" },
  { code: "KE", dial: "+254", label: "Kenya" },
  { code: "IL", dial: "+972", label: "Israel" },
  { code: "SA", dial: "+966", label: "Saudi Arabia" },
];

const digitsOnly = (s) => (s || "").replace(/\D/g, "");

export const toE164 = (dial, national) => {
  const nat = digitsOnly(national);
  if (!nat) return "";
  return `${dial}${nat}`;
};

// Break an E.164 (or legacy raw) value into { code, dial, national }.
export const splitE164 = (value) => {
  const raw = (value || "").trim();
  const digits = digitsOnly(raw);
  if (!digits) return { code: "US", dial: "+1", national: "" };
  // Only treat as international when an explicit + prefix is present.
  if (raw.startsWith("+")) {
    const sorted = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
    for (const c of sorted) {
      const dd = digitsOnly(c.dial);
      if (digits.startsWith(dd)) {
        return { code: c.code, dial: c.dial, national: digits.slice(dd.length) };
      }
    }
  }
  // Legacy US-style value stored without a country code.
  const us = digits.length > 10 && digits.startsWith("1") ? digits.slice(1) : digits;
  return { code: "US", dial: "+1", national: us };
};
